module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00066.27d45bcd.jpg";